import React from 'react';
import { Tab } from '@gerdau/hefesto/Tab';
import {
  EOrderTab,
  ILongSteelOrderData
} from '../../../../store/ducks/long-steel-orders/types';
import { Container } from './styles';
import { StateZeroTableMessage } from '../../../../components/Commons/Tables/styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { ECustomerTypeView } from '../../../../store/ducks/user/types';
import OpenOrders from './OpenOrders';
import BilledOrders from './BilledOrders';
export interface IOrderTab {
  name: string;
  status: EOrderTab;
}
interface IOrderTabsProps {
  selectedTab?: EOrderTab;
  onChangeTab(tab: EOrderTab): void;
  filteredOrders: ILongSteelOrderData[];
  loading: boolean;
  isStateZero: boolean; // se não tiver feito nenhuma busca ainda
  customerViewType: ECustomerTypeView;
  setFilteredOrders(filteredOrders: ILongSteelOrderData[]): void;
  onCleanFilters(): void;
  loadOrders(
    states: string[],
    emitterIds: string[],
    startDate?: string,
    endDate?: string
  ): void;
  receiverId: string;
  setReceiverId(receiverId: string): void;
  receiverBilledId: string;
  setReceiverBilledId(receiverId: string): void;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
}

const OrdersTabs: React.FC<IOrderTabsProps> = ({
  selectedTab,
  onChangeTab,
  filteredOrders,
  loading,
  isStateZero,
  customerViewType,
  setFilteredOrders,
  onCleanFilters,
  loadOrders,
  receiverId,
  setReceiverId,
  receiverBilledId,
  setReceiverBilledId,
  emitterIds,
  setEmitterIds
}) => {
  const user = useSelector((state: ApplicationState) => state.user);

  const onChange = (status: EOrderTab | string) => {
    onChangeTab(status as EOrderTab);
  };

  return (
    <Container>
      <Tab
        data-testid="tab-orders"
        onChange={onChange}
        activeKey={selectedTab || ''}
        tabItems={[
          {
            key: 'open',
            name: 'Pedidos em aberto',
            content: (
              <>
                {!isStateZero ? (
                  <OpenOrders
                    loading={loading}
                    customerViewType={customerViewType}
                    selectedTab={selectedTab}
                    filteredOrders={filteredOrders}
                    setFilteredOrders={setFilteredOrders}
                    onCleanFilters={onCleanFilters}
                    loadOrders={loadOrders}
                    receiverId={receiverId}
                    setReceiverId={setReceiverId}
                    emitterIds={emitterIds}
                    setEmitterIds={setEmitterIds}
                  />
                ) : (
                  <StateZeroTableMessage isFacelift>
                    {(customerViewType === ECustomerTypeView.EMITTER ||
                      user.isManager) && (
                      <>
                        <span className="description-facelift">
                          Para visualizar seus pedidos,
                        </span>
                        <span className="description-facelift__bold">
                          &nbsp; selecione o(s) emissor(es) no filtro acima.
                        </span>
                      </>
                    )}

                    {(customerViewType === ECustomerTypeView.RECEIVER ||
                      customerViewType ===
                        ECustomerTypeView.FABRICATION_RECEIVER) && (
                      <>
                        <span className="description-facelift">
                          Para visualizar seus pedidos,
                        </span>
                        <span className="description-facelift__bold">
                          &nbsp; selecione o(s) recebedor(es) desejado(s).
                        </span>
                      </>
                    )}
                  </StateZeroTableMessage>
                )}
              </>
            )
          },
          {
            key: 'billed',
            name: 'Pedidos faturados',
            content: (
              <>
                {!isStateZero ? (
                  <BilledOrders
                    loading={loading}
                    isStateZero={isStateZero}
                    customerViewType={customerViewType}
                    selectedTab={selectedTab}
                    filteredOrders={filteredOrders}
                    setFilteredOrders={setFilteredOrders}
                    onCleanFilters={onCleanFilters}
                    loadOrders={loadOrders}
                    receiverBilledId={receiverBilledId}
                    setReceiverBilledId={setReceiverBilledId}
                    emitterIds={emitterIds}
                    setEmitterIds={setEmitterIds}
                  />
                ) : (
                  <StateZeroTableMessage isFacelift>
                    {(customerViewType === ECustomerTypeView.EMITTER ||
                      user.isManager) && (
                      <>
                        <span className="description-facelift">
                          Para visualizar seus pedidos,
                        </span>
                        <span className="description-facelift__bold">
                          &nbsp; selecione o(s) emissor(es) no filtro acima.
                        </span>
                      </>
                    )}

                    {(customerViewType === ECustomerTypeView.RECEIVER ||
                      customerViewType ===
                        ECustomerTypeView.FABRICATION_RECEIVER) && (
                      <>
                        <span className="description-facelift">
                          Para visualizar seus pedidos,
                        </span>
                        <span className="description-facelift__bold">
                          &nbsp; selecione o(s) recebedor(es) desejado(s).
                        </span>
                      </>
                    )}
                  </StateZeroTableMessage>
                )}
              </>
            )
          }
        ]}
      />
    </Container>
  );
};

export default OrdersTabs;
